import { render, staticRenderFns } from "./MyActivityPage.vue?vue&type=template&id=b9ee5afa&"
import script from "./MyActivityPage.vue?vue&type=script&lang=js&"
export * from "./MyActivityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports